import { render, staticRenderFns } from "./QuestionSearch.vue?vue&type=template&id=cd81be44&scoped=true"
import script from "./QuestionSearch.vue?vue&type=script&lang=js"
export * from "./QuestionSearch.vue?vue&type=script&lang=js"
import style0 from "./QuestionSearch.vue?vue&type=style&index=0&id=cd81be44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd81be44",
  null
  
)

export default component.exports